const HistoryRoomController = function ({nextStep, nextRound, prevStep, prevRound, autoplayToggle, isAutoplayActive}) {

    return (
        <div className='history-controllers'>
            <i className={'icon-rw'} onClick={prevRound}/>
            <i className={'icon-back'} onClick={prevStep}/>
            <i className={isAutoplayActive ? 'icon-pause' : 'icon-play'} onClick={autoplayToggle}/>
            <i className='icon-next' onClick={nextStep}/>
            <i className={'icon-fwd'} onClick={nextRound}/>
        </div>
    )
}
export default HistoryRoomController